import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useLocale } from '@/lib/hooks/use-locale';
import type { ExplorerTopLevelEntity } from '@/server/utils/explorer-utils';
import { allExplorerTabs } from '@/server/utils/explorer-utils';

type Props = {
    className?: string;
    tabsToShow?: ExplorerTopLevelEntity[];
    selectedTab: ExplorerTopLevelEntity;
    onTabChange: (tab: ExplorerTopLevelEntity) => void;
};

export const ExplorerTopLevelEntityTabs: React.FC<Props> = ({
    selectedTab,
    onTabChange,
    tabsToShow = allExplorerTabs,
}) => {
    const { t } = useLocale();

    const handleValueChange = (value: string) => {
        onTabChange(value as ExplorerTopLevelEntity);
    };

    return (
        <RadioGroup
            value={selectedTab}
            onValueChange={handleValueChange}
            className="scrollbar-none flex shrink-0 overflow-x-auto"
        >
            {tabsToShow.map((tab) => (
                <RadioGroupItem value={tab} id="option-one" key={tab}>
                    {t(`header_tab__${tab}`, { ns: 'explorer' })}
                </RadioGroupItem>
            ))}
        </RadioGroup>
    );
};
